import React from 'react';
import styled from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { init } from 'Libs/apollo';
import { GlobalStyle, AppStyled } from '../GlobalStyle';
import { BrowserRouter } from 'react-router-dom';
import AuthStore from 'Store/AuthStore';
import InitiStore from 'Store/InitiStore';
import UiStore from 'Store/UiStore';

import Media from 'react-media';
import SideMenu from 'Components/SideMenu';
import DesktopHeader from 'Components/Header/DesktopHeader/HeaderDesktopExternal';
import MobileHeader from 'Components/Header/MobileHeader/HeaderMobileExternal';
import ModalContainer from 'react-modal-promise';
import Toaster from 'Components/Toaster';
import SearchAutoSuggest from 'Components/SearchAutoSuggest';
import DesignStore from 'Store/DesignStore';
import { DynamicStylesExternal } from 'Components/DynamicStylesExternal';

const HeaderContainer = styled.div`
  /* Masquer le header tant que les couleurs ne sont pas chargées pour éviter le FOUC */
  opacity: 0;
  transition: opacity 0.2s ease-in;

  &.loaded {
    opacity: 1;
  }
`;

// Composant interne qui utilise le store
const HeaderContent = () => {
  const isLoaded = DesignStore.useStoreState((state) => state.isLoaded);

  return (
    // <HeaderContainer className={isLoaded ? 'loaded' : ''}>
    <>
      <SideMenu />
      <Media query={{ minWidth: 768 }}>
        <DesktopHeader />
      </Media>
      <Media query={{ maxWidth: 767 }}>
        <MobileHeader />
      </Media>
    </>
    // </HeaderContainer>
  );
};

export default () => {
  const client = init();

  return (
    <AppStyled>
      <BrowserRouter>
        <AuthStore.Provider initialData={client}>
          <DesignStore.Provider initialData={client}>
            <UiStore.Provider>
              <ApolloProvider client={client}>
                <InitiStore />
                <>
                  <Toaster />
                  <GlobalStyle />
                  <DynamicStylesExternal />
                  <HeaderContent />
                  <ModalContainer />
                </>
              </ApolloProvider>
            </UiStore.Provider>
          </DesignStore.Provider>
        </AuthStore.Provider>
      </BrowserRouter>
    </AppStyled>
  );
};
